$(function(){

    var body = $('html, body'),
        $window = $(window);

    function isOldIE() {
        var ua = window.navigator.userAgent; //Check the userAgent property of the window.navigator object
        var msie = ua.indexOf('MSIE '); // IE 10 or older
        var trident = ua.indexOf('Trident/'); //IE 11

        return (msie > 0 || trident > 0);
    }

    if (isOldIE()){
        body.addClass('ie')
    }


    var Navigation = {

    selectors: {
      linkActiveClass: 'active',
      mainNavLink : $('.js-nav-item'),
      destinationBlock : $('.js-section'),
    },

    init: function(){

      var self = this;
      this.selectors.mainNavLink.on('click', function(e) {
        e.preventDefault();
        var sectionId = $(this).data('scroll-nav'),
          currentLink =  self.findCurrentLink(sectionId);

        Utils.scrollTo($('#' + sectionId).offset().top - Header.headerHeight, function(){
          self.updateClass(currentLink)
        });
      });

      this.selectors.destinationBlock.each(function(){
        var section = $(this),
          sectionId = section.attr('id'),

          top = section.offset().top -5 ,
          bottom = section.height() + top,
          correspondingNavLink = self.findCurrentLink(sectionId);

        self.updatePosition(top, bottom, correspondingNavLink);

        $window.on('scroll', function(){
          self.updatePosition(top, bottom, correspondingNavLink)
        })
      });
    },

    updatePosition: function(top, bottom, correspondingNavLink){
      if($window.scrollTop() + Header.headerHeight > top && $window.scrollTop() < bottom) {
        this.updateClass(correspondingNavLink);
      }
    },

    updateClass: function(currentLink){
      this.selectors.mainNavLink.removeClass(this.selectors.linkActiveClass);
      currentLink.addClass(this.selectors.linkActiveClass);
    },

    findCurrentLink: function(sectionId){
      return this.selectors.mainNavLink.filter(function(){return $(this).data('scroll-nav') == sectionId})
    }
  };

  /*Fixed header */

  var Header = {
    breakpoints: {
      noFixed: 850,
    },
    headerHeight: 0,
    contentStart: 0,

    selectors: {
      fixedHeader : $('.js-nav'),
      fixedHeaderClass : 'nav--fixed',

    },

    init: function(){
      this.contentStart = $('.js-content').offset().top;
      this.headerHeight = this.selectors.fixedHeader.outerHeight();
      var self = this;
      this.setHeaderPosition();

      $window.on('scroll', function(){
        self.setHeaderPosition()
      });
      $window.on('resize', function(){
        self.headerHeight = self.selectors.fixedHeader.outerHeight();
        self.setHeaderPosition()
      });
    },

    setHeaderPosition: function(){

      var wWidth = $window.width();
      if (wWidth < this.breakpoints.noFixed){
        this.selectors.fixedHeader.removeClass(this.selectors.fixedHeaderClass);
      } else {
        if($window.scrollTop() > this.contentStart - this.headerHeight) {
          this.selectors.fixedHeader.addClass(this.selectors.fixedHeaderClass);
        } else {
          this.selectors.fixedHeader.removeClass(this.selectors.fixedHeaderClass);
        }
      }
    }

  };

  var Utils = {

    filterItem: function(collection, dataAttr, dataAttrValue) {
      return collection.filter(function(){
          return $(this).data(dataAttr) == dataAttrValue || $(this).attr('data-' + dataAttr) == dataAttrValue;
      })
    },

      filterItemOut: function(collection, dataAttr, dataAttrValue) {
          return collection.filter(function(){
              return $(this).data(dataAttr) != dataAttrValue
          })
      },

    scrollTo: function(destination, callback){
      $('html, body').animate({
        scrollTop: destination
      }, 1000, callback);
    }
  };

  var Tabs = {

    selectors: {
      tab: $('.js-tab'),
      trigger: $('.js-tab-trigger'),
      triggerActiveClass: 'pack--active'
    },

    init: function(){
      var self = this;
      var currentTab = '1';
      this.selectors.trigger.on('click', function(){
          var nextTab = $(this).data('tab');
          if (currentTab !== nextTab) {
              currentTab = nextTab;
              self.selectors.tab.hide();
              var tabsToshow = Utils.filterItem(self.selectors.tab, 'tab',  $(this).data('tab'));
              tabsToshow.each(function(){
                  var effect = $(this).data('effect');
                  effect ? $(this)[effect]() : $(this).fadeIn()
              });
              self.selectors.trigger.removeClass(self.selectors.triggerActiveClass);
              Utils.filterItem(self.selectors.trigger, 'tab',  $(this).data('tab')).addClass(self.selectors.triggerActiveClass);
          }
      });

      Utils.filterItem(self.selectors.trigger, 'tab',  currentTab).click();
    }
  };

  var Slider = {

      selectors: {
        slider: $('.js-char-slider'),
          activeSlideClass: 'char--current',
          sliderNextNav: $('.js-slider-next'),
          sliderPrevNav: $('.js-slider-prev'),
          char: '.js-char',
          rotationClass: 'description',
          rotationIcon: '.js-rotation-i',
          rotateWrapper: '.js-char-rotation'
      },

      init: function(){
          var self = this;

         this.initSlider();

          this.selectors.slide = $('.owl-item');

          this.selectors.sliderNextNav.on('click', function(){
              self.slider.trigger('next.owl.carousel');
          });

          this.selectors.sliderPrevNav.on('click', function(){
              self.slider.trigger('prev.owl.carousel');
          });

          this.activateSlides();

          this.slider.on('changed.owl.carousel', function(event) {
              setTimeout(function () {
                  self.activateSlides();
                  self.addRotationAnimation();
              })
          });

          this.slider.on('resized.owl.carousel', function(event) {
              setTimeout(function () {
                  self.addSlideClick();
              })
          });

          this.addSlideClick();
          this.addRotationAnimation()
      },

      addRotationAnimation: function(){
          var self = this;
          $(this.selectors.char).off().hover(
              function(){
                  Utils.filterItem($(this).find(self.selectors.rotationIcon), 'target', 'description').fadeIn();
              }, function(){
                  $(this).find(self.selectors.rotationIcon).hide();
                  $(this).find(self.selectors.rotateWrapper).removeClass(self.selectors.rotationClass)
              });

          $(this.selectors.rotationIcon).off().on('click', function(e){
              e.stopPropagation();
              self.setRotationState($(this).closest(self.selectors.char), $(this).data('target'));
          })
      },

      setRotationState: function(char, target){
          char.find(this.selectors.rotationIcon).fadeOut();
          Utils.filterItemOut(char.find(this.selectors.rotationIcon), 'target', target).fadeIn();
          char.find(this.selectors.rotateWrapper).removeClass('description features').addClass(target)
      },

      addSlideClick: function(){
          var self = this;
          $('.owl-item').off().on('click', function(){
              var activePosition = $('.active.char--current').attr('data-active');
              var target = $(this).attr('data-active');

              var difference = activePosition - target;
              var direction = difference > 0 ? 'prev' :  'next';

              for (var i =0; i< Math.abs(difference); i++){
                  self.slider.trigger( direction+'.owl.carousel');
              }
          })
      },

      initSlider: function(){
          var itemsNumber = this.getSlidesNumber();

          this.slider = this.selectors.slider.owlCarousel({
              items: itemsNumber,
              loop: true,
              mouseDrag: false,
              responsive: {
                  0:{
                      items:1
                  },
                  900:{
                      items:3
                  },
                  1500:{
                      items:5
                  },
                  2100: {
                      items: 7
                  }
              }
          });
      },

      activateSlides: function(){
          $('.owl-item').removeAttr('data-active').css('opacity', 1);
          var activeSlides = $('.owl-item.active');
          activeSlides.each(function(index){
              $(this).attr('data-active', index);
          });

          var middle = Math.floor(this.getSlidesNumber()/2);

          activeSlides
              .removeClass(this.selectors.activeSlideClass)
              .eq(middle).addClass(this.selectors.activeSlideClass).css('opacity', 1);

          var slidesOpacity = {
              1: '.8',
              2: '.5',
              3: '.2'
          };

          activeSlides.each(function(i){
              for (var positionFromCenter in slidesOpacity) {
                  if (middle - (+positionFromCenter) === i || middle + (+positionFromCenter) === i){
                      $(this).css('opacity', slidesOpacity[positionFromCenter])
                  }
              }
          })
      },

      getSlidesNumber: function(){
          var slidesNumber = 1;

          var wWidth = $(window).width();

          if (wWidth > 2100){
              slidesNumber = 7
          } else if (wWidth > 1500){
              slidesNumber = 5
          } else if (wWidth > 900){
              slidesNumber = 3
          }

          return slidesNumber
      }
  };

    var Guns = {
        selectors: {
            trigger: $('.js-gun'),
            triggerActiveClass: 'guns__thum--active',
            target: $('.js-gun-image'),
            name: $('.js-gun-name'),
            statItem: $('.js-stat'),
            active: $('.guns__premium-i--active'),
            premiumTrigger: $('.js-premium-weapon'),
            premiumActiveClass: 'guns__premium--active',
            premiumInactiveClass: 'guns__premium--inactive'
        },

        isPremiumOn: false,
        current: null,

        init: function(){
            var self = this;
            this.selectors.trigger.on('click', function(){
                self.changeGun($(this))
            });

            this.selectors.trigger.eq(0).click();
        },

        getImgPath(gun){
            var imgPath = gun.find('img').attr('src').slice(0,-4);
            imgPath += this.isPremiumOn && this.hasGunPremium(this.current) ? '--l--premium.png' : '--l.png';
            return imgPath
        },

        hasGunPremium: function(gunTrigger){
            return !!gunTrigger.data('premium');
        },

        changeGunImage(){
            this.selectors.target.attr('src', this.getImgPath.bind(this, this.current));
        },

        changeGun: function(current){

            this.current = current;

            var self = this;

            if (this.hasGunPremium(current)) {
                self.selectors.premiumTrigger.removeClass(self.selectors.premiumInactiveClass);
                if (self.isPremiumOn) {
                    self.selectors.premiumTrigger.addClass(self.selectors.premiumActiveClass);
                }
                this.selectors.premiumTrigger.off().on('click', function(){
                    self.isPremiumOn = !self.isPremiumOn;
                    self.selectors.premiumTrigger.toggleClass(self.selectors.premiumActiveClass);
                    self.changeGunImage();
                });
            } else {
                self.selectors.premiumTrigger.removeClass(self.selectors.premiumActiveClass).addClass(self.selectors.premiumInactiveClass)
            }

            this.selectors.trigger.removeClass(this.selectors.triggerActiveClass);
            current.addClass(this.selectors.triggerActiveClass);
            this.selectors.name.text(current.data('name'));
            this.changeGunImage();

            var stats = ['damage', 'accuracy', 'rate', 'range'];


            stats.forEach(function(stat){
                var statValue = current.data(stat);
                Utils.filterItem(self.selectors.statItem, 'stat', stat).css('width', statValue + '%')
            })
        }
    };



  Navigation.init();
  Header.init();
  Tabs.init();
  Slider.init();
  Guns.init();
  Shadowbox.init({});


});
